<template>
    <div>
        <span>{{ $_.get(activity, 'actorUser.name') || 'Bilinmeyen Kullanıcı' }} kullanıcısı "{{ $_.get(activity, 'payload.taskTitle') || 'Bilinmeyen Görev' }}" adlı göreve {{ $_.get(activity, 'payload.subtaskCount') || 0 }} alt görev ekledi: {{ ($_.get(activity, 'payload.subtasks') || []).join(', ') || 'Alt görevler' }}.</span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "TaskAddedSubtask",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>
<style scoped lang="scss"></style>
